import {FONT_SIZE, THEME_COLORS} from "../styles";
import {StyleProp, Text, TouchableOpacity, View, ViewStyle} from "react-native";
import React from "react";

interface ITabOneProps {
    topText: string;
    topRightText?: string;
    topRightTextColor?: string;
    bottomSecondText?: string;
    bottomSecondTextColor?: string;
    bottomText: string;
    onPress: () => void;
    disabled?: boolean;
    style?: StyleProp<ViewStyle>;
    isSelected?: boolean;
}

export const TabOne = (props: ITabOneProps) => {
    const {topText, bottomText, onPress, disabled, style, topRightText, topRightTextColor, isSelected, bottomSecondText, bottomSecondTextColor} = props;
    const selectOpacity1 = isSelected ? 1: 0.6;
    const selectOpacity2 = isSelected ? 1: 0.8;
    return <TouchableOpacity onPress={onPress} disabled={disabled}
                             style={[{
                                 marginHorizontal: 10,
                                 paddingVertical: 4,
                                 paddingTop: 2,
                             }, style]}>
        <View style={{alignItems: 'center', flexDirection: "row"}}>
            <Text style={{
                color: THEME_COLORS.white, fontWeight: "bold",
                fontSize: FONT_SIZE.tabFontSize,
                opacity: selectOpacity1,
            }}>{topText}</Text>
            {!!topRightText ? <Text style={{
                color: !!topRightTextColor ? topRightTextColor : THEME_COLORS.white,
                fontWeight: "bold",
                alignSelf: "flex-start",
                marginLeft: 2,
                fontSize: FONT_SIZE.s2,
                opacity: selectOpacity2,
            }}>{topRightText}</Text> : null}
        </View>
        <Text style={{
            color: THEME_COLORS.white, fontWeight: "bold",
            fontSize: FONT_SIZE.s1,
            opacity: selectOpacity1,
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 1,
            wordBreak: 'break-word'
        }}>{bottomText}</Text>
        {!!bottomSecondText ? <Text style={{
            color: !!bottomSecondTextColor ? bottomSecondTextColor : THEME_COLORS.white,
            fontWeight: "500",
            alignSelf: "flex-start",
            fontSize: FONT_SIZE.s3,
            opacity: selectOpacity2,
        }}>{bottomSecondText}</Text> : null}
    </TouchableOpacity>
}
